import * as React from 'react';
import {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import center from '../../assets/main/center.png';
import Circle from "../CircleProgress";
import * as util from "../../utils/util";
import api from "../../utils/api";
import Typography from "@mui/material/Typography";
import iconEating from '../../assets/icon/iconEating.gif';
import iconExercise from '../../assets/icon/iconExercise.gif';
import iconMonk from '../../assets/icon/iconMonk.gif';
import iconWater from '../../assets/icon/iconWater.gif';
import Skeleton from '@mui/material/Skeleton';
import {useNavigate} from "react-router-dom";

interface Window {
  ReactNativeWebView: {
    postMessage: (message: string) => void;
  };
}
type TargetItem = { title: string, target: any, val: any, titleName: string };

const MainChart = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  // 조회 실패 상태. 홈 화면이라 alert 로 막지 않고 자리에 안내만 남긴다.
  const [failed, setFailed] = React.useState(false);
  // 더미 1개로 시작하지 않는다. concat 누적이면 더미가 남고 재호출 시 항목이 중복된다.
  const [targetList, setTargetList] = useState<TargetItem[]>([]);
  const [step, setStep] = React.useState(0);

  // 조회를 함수로 빼 둔다 — 재시도 버튼이 리스너 등록까지 다시 하지 않도록.
  function loadTargets() {
    setLoading(true);
    setFailed(false);

    api.get(`app/api/v1/AP_002_001`).then(res => {
      const resData = res.data.result_data;
      const healthKey = Object.keys(resData.health);
      const list: TargetItem[] = [];
      for (let item of healthKey) {
        let itemTitleName = '';
        if (item === 'meal') itemTitleName = '식사 kcal';
        else if (item === 'exercise') itemTitleName = '운동 kcal';
        else if (item === 'moisture') itemTitleName = '수분량';
        else if (item === 'step') itemTitleName = '걸음수';
        list.push({ title: item, target: resData.target[item], val: resData.health[item], titleName: itemTitleName });
      }
      setTargetList(list);
    }).catch(function (error) {
      console.log(error);
      setFailed(true);
    }).finally(function () {
      // 실패해도 로딩 표시는 반드시 걷는다 — 예전에는 loading 이 true 로 굳은 채
      // 목록도 비어 있어 홈에서 이 영역이 통째로 사라진 것처럼 보였다.
      setLoading(false);
    });
  }

  useEffect(() => {
    loadTargets();

    if (util.strNull(window.localStorage.userCusID) === '') return;

    // 걸음수 저장을 위한 리스너 android, ios 구분하는 코드
    const receiver: any = navigator.userAgent.includes("Android")
      ? document
      : window;
    receiver.addEventListener("message", listener);
    postMessage('GetSteps', '');

    // 정리하지 않으면 홈에 재진입할 때마다 리스너가 누적된다.
    return () => {
      receiver.removeEventListener("message", listener);
    };
  }, []);
  
  const postMessage = (type: string, data: any) => {
    var win: any = window;
    win.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
  };

  const listener = (event: any) => {
    if (typeof event.data !== 'string') return;  // web => object, app => string

    // 앱이 보낸 JSON 이 아닌 문자열 메시지(HMR, 브라우저 확장 등)도 이 리스너로 들어온다.
    // 방어 없이 파싱하면 그때마다 예외가 발생한다.
    let appData: any;
    try {
      appData = JSON.parse(event.data);
    } catch {
      return;
    }

    if (appData && appData.type === "steps") {
      setStep(appData.data);
    }
  };

  // 걸음수 저장
  function handleClickMoveHistory(){
    const saveParams = { date: '', step: 0 };
    saveParams.date = util.getDateByCustom('yyyy-MM-dd', 0);
    saveParams.step = step;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      api.post(`app/api/v1/AP_002_009`, saveParams).then(res => {
        navigate('/history');
      }).catch(function (error) {
        console.log(error)
      });
    }
    
  }


  return (
    <React.Fragment>
      <Stack direction={'row'} spacing={1} justifyContent={'center'} alignContent={'center'} sx={{
        pt: 3, width: '100%', boxSizing: 'border-box', mt: 2,
        '& .MuiBox-root .MuiGauge-root': { width: '100%', height: '100%' },
        '& .MuiBox-root:nth-of-type(1) .CircleChart': {
          backgroundImage: `url(${iconEating})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "35%",
          backgroundPosition: 'center center'

        },
        '& .MuiBox-root:nth-of-type(2) .MuiGauge-valueArc': { fill: '#ff5454' },
        '& .MuiBox-root:nth-of-type(2) .CircleChart': {
          backgroundImage: `url(${iconExercise})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "35%",
          backgroundPosition: 'center center'

        },
        '& .MuiBox-root:nth-of-type(3) .MuiGauge-valueArc': { fill: '#e029ff' },
        '& .MuiBox-root:nth-of-type(3) .CircleChart': {
          backgroundImage: `url(${iconMonk})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "35%",
          backgroundPosition: 'center center'

        },
        '& .MuiBox-root:nth-of-type(4) .MuiGauge-valueArc': { fill: '#33cccc', },
        '& .MuiBox-root:nth-of-type(4) .CircleChart': {
          backgroundImage: `url(${iconWater})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "35%",
          backgroundPosition: 'center center'

        }
      }}>

        {/* 조용히 사라지지 않게 — 무슨 일인지 알리고 다시 시도할 길을 준다 */}
        {failed && !loading ? (
          <Stack alignItems={'center'} sx={{ width: '100%', bgcolor: '#fff', borderRadius: '20px', py: 2 }} spacing={0.5}>
            <Typography sx={{ fontSize: 13, color: '#888' }}>오늘 목표를 불러오지 못했습니다.</Typography>
            <Typography component="span" onClick={loadTargets} sx={{ fontSize: 13, color: '#EF8322', fontWeight: 700, cursor: 'pointer' }}>
              다시 시도
            </Typography>
          </Stack>
        ) : null}

        {targetList && targetList.filter((v: any) => v.title !== '').slice(0, 4).map((item, index) => (
          <React.Fragment key={item.title || index}>
            <Box sx={{
              bgcolor: '#fff', borderRadius: '20px', width: '100%', 
              '& .circleText': { fontSize: 14, display: 'none' },
              '& .CircleChart:nth-of-type(4)': {
              }
            }} onClick={handleClickMoveHistory}>
              {loading ? (
                <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', }} justifyContent='center' alignItems={'center'} alignContent={'center'}>
                  <Skeleton animation="wave" variant="circular" height={60} width={60} sx={{mt:1, mb:.5}} />
                  <Skeleton animation="wave" variant="rounded" height={18} width='80%' sx={{ borderRadius: 3, my: 1, }} />
                  <Skeleton animation="wave" variant="rounded" height={18} width='80%' sx={{ borderRadius: 3, mb:2 }} />
                </Stack>
              ) : (
                <Stack direction={'column'} justifyContent={'center'}>
                  <Circle progress={{ goal: item.target, value: item.val }} sx={{}} />
                  <Typography sx={{ fontSize: 12, color: '#777', textAlign: 'center', pb: 1 }}>{item.titleName}</Typography>
                  <Typography sx={{ fontSize: 12, color: '#777', textAlign: 'center', pb: 2, fontWeight: 700 }}>{item.val}<Typography component={'span'} sx={{ fontSize: 12, color: '#777', textAlign: 'center', pb: 1 }}>/{item.target}</Typography></Typography>
                </Stack>
              )}
            </Box>
          </React.Fragment>
        ))}

      </Stack>
    </React.Fragment>
  );
}

export default MainChart;

